import { parseDate } from './parseDate';

export function getDBTimestampFromDate(date) {
    if (!date) {
    	date = new Date();
    }

    const pd = parseDate(date);

    return `${pd.YYYY}${pd.MM}${pd.DD} ${pd.HH}:${pd.mm}:00`;
}
